import { render, staticRenderFns } from "./ContactProperty.vue?vue&type=template&id=5841b114&"
import script from "./ContactProperty.vue?vue&type=script&lang=js&"
export * from "./ContactProperty.vue?vue&type=script&lang=js&"
import style0 from "./ContactProperty.vue?vue&type=style&index=0&id=5841b114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports